var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((3),function(n){return _c('div',{key:n,staticClass:"p-y-18 p-x-21"},[_c('TimeLineItemShimmer',{attrs:{"is-small":true}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }